import apiClient from "./apiClient";

// ================= SUBJECT =================
export const getSubjects = async () => {
  const res = await apiClient.get("/api/subjects");
  return res.data;
};

// ================= CHAPTER =================
export const getChapterTopic = async (payload) => {
  const res = await apiClient.post("/Panel/GetChapterTopic", {
    classid: Number(payload.classId),
    subjectid: Number(payload.subjectId),
  });

  return res.data;
};

//=======================GetTopicByChapterId=================
export const getTopicsByChapter = async (chapterId) => {
  const res= await apiClient.post("/Topics/GetTopicsByChapterID",
  {
      id: chapterId,
    })
     return res.data;
  }

// ================= Get PAST SESSIONS userid class subject chapter topic  id =================
export const getFilteredSessions = async (filters, userId) => {
  const payload = {
    userUniuqeId: 
    Number(userId),
    schoolId: 11,
    classId:
     Number(filters.classId),
    subjectId: Number(filters.subject) || 0,
    sectionId: 36, // dynamic if needed
     chapterId:Number(filters.chapter) || 0,
    topicId: Number(filters.topic) || 0,
     date: filters.date || null,
  };

  const res = await apiClient.post(
    "/LiveClasses/GetAllLiveClasses",
    payload
  );
  console.log("Test user response =",res)

  return res.data;
};

//===============Get content by topic id ==================
export const getContentsByTopicID = async (topicId) => {
    try {
        const res = await apiClient.post(
            `/Contents/GetContentsByTopicID`,
            {
                ID: topicId
            }
        );

        return res.data;
    } catch (err) {
        console.error(err);
        return [];
    }
};

//==============Save Attendance===================
export const markAttendance = async (payload) => {

  const response = await apiClient.post(
    "/LiveClasses/MarkAttendance",
    payload
  );

  return response.data;
};

//================Get